import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';

import { ContractService } from '../../../../services/contract.service';
import { AccountService } from '../../../../services/account.service';
import { NgForm, NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { AddContract } from '../../../../models/AddContract';
import { AdminService } from '../../../../services/Admin.service';
import { ConfirmationPageFailComponent } from '../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
/*tslint:disable:max-line-length */
import { ConfirmationPageSuccessComponent } from '../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
/*tslint:enable:max-line-length */
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../shared-components/busy-indicator/busy-indicator.component';
import { DataService } from '../../../../services/data.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { UserDisplayInfo } from '../../../../models/UserDisplayInfo';
import { User } from '../../../../models/User';
import { stringify } from '@angular/compiler/src/util';
import { LoginResult } from '../../../../models/LoginResult';
import { setTimeout } from 'timers';

@Component({
  selector: 'app-universallogin',
  templateUrl: './universallogin.component.html',
  styleUrls: ['./universallogin.component.scss']
})
export class UniversalloginComponent implements OnDestroy, OnInit {
  @Output()
  closeModel: EventEmitter<any> = new EventEmitter(); //creating an output event
  @Output()
  onChangeSubStep: EventEmitter<any> = new EventEmitter();
  passwordConfirm: Boolean;
  ErrorMessage: string;
  successMsg: string;
  _router: Router;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  alive = true;
  UniversalEmail = '';
  LID = '';
  confirmEmail: boolean;
  loUser: User = new User();
  @ViewChild('frmAddContract') frmAddContract: NgForm;
  emailmatchMsg: string;
  Password: string;
  nextbutton: boolean;
  submitbutton: boolean;
  step:number;
  chgpasswordURL:string;
  showlinkAcc:boolean;
  pwdToken;string;
  subStep = 1;
  circleArray = [1, 2, 3, 4, 5];
  constructor(private adminService: AdminService,
    public dataService: DataService,
    public accountSvc: AccountService,
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private contractService: ContractService) {
    this._router = router;
    if (this.dataService.userDisplayInfo) {
      this.UniversalEmail = this.dataService.userDisplayInfo.UniversalEmail;
    }
  }

  ngOnInit() {
    this.spinner.hide();
    this.nextbutton = true;
    this.step = 0;
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
    if (this.dataService.userDisplayInfo) {
      this.UniversalEmail = this.dataService.userDisplayInfo.UniversalEmail;
    }
  }
  goToMyContract(event) {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
    this.ErrorMessage = null;
    this.closeModel.emit(null);
    // window.close();
  }

  close(event) {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }
  checkEmailExists() {
    this.emailmatchMsg = '';
    this.dataService.userDisplayInfo.UniversalEmail = this.UniversalEmail;
    this.accountSvc.isEmailAlreadytExists(this.dataService.userDisplayInfo.UniversalEmail)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          if (data === true) {
            this.successMsg = null;
            this.emailmatchMsg = this.UniversalEmail + ' is already associated with a JSSI Parts and/or a Conklin & de Decker account. Please use a different email for your login process to complete.';
          } else {
            this.emailmatchMsg = '';
          }
        },
        err => {

          this.successMsg = null;
          // this.errorMsg = err;
          this.emailmatchMsg = '';

        }
      );
  }

  checkregisterUniversalEmailExists() {
    this.emailmatchMsg = '';
    this.confirmEmail = false;
    this.submitbutton = true;
    this.nextbutton = false;
    // this.dataService.userDisplayInfo.UniversalEmail = this.UniversalEmail;
    this.LID = this.dataService.userDisplayInfo.LID;
    // this.checkEmailExists();
    if (this.emailmatchMsg === '') {
      console.log('this.emailmatchmsg', this.emailmatchMsg);
      this.spinner.show();
      this.accountSvc.isRegisterUniversalEmailExists(this.UniversalEmail, this.LID)
        // .takeWhile(() => this.alive)
        .subscribe(
          data => {
            this.spinner.hide();
            console.log('data userGuid', data);
            if (data.Myjssiexists === true) {
              //  this.nextbutton = true;
              this.submitbutton = true;
              this.showSuccessConfirmation = false;
              this.showFailConfirmation = false;
              this.emailmatchMsg = this.UniversalEmail + ' is already associated with a JSSI Parts and/or a Conklin & de Decker account. Please use a different email for your login process to complete.';
            } else if (data.exists === true) {
              // this.nextbutton  = true;
              this.submitbutton = false;
              this.showSuccessConfirmation = false;
              this.showFailConfirmation = false;
              this.confirmEmail = true;
              this.showlinkAcc = true;

              this.dataService.userDisplayInfo.id = data.userId;
              //   this.successMsg = 'We have  sent a confirmation email to ' + this.UniversalEmail +
              //   ' Please click the link in that email to verify your account. Once you have verified your email via the link your account set to proceed with your login. ';
            } else {
              // this.submitbutton = true;
              this.nextbutton = false;
              this.emailmatchMsg = '';
              this.showSuccessConfirmation = false;
              this.showFailConfirmation = false;
              this.step = 3;
              this.addNewContract();
            }
          },
          err => {

            this.successMsg = null;
            // this.errorMsg = err;
            this.emailmatchMsg = '';

          }
        );
    }

  }

  public addNewContract() {
    this.passwordConfirm = false;
    // this.checkregisterUniversalEmailExists();
    if (this.emailmatchMsg !== '') {
      return;
    } else if (this.confirmEmail && !this.Password) {
      return;
    } else if (this.Password) {
      //call updatemyjssi universal method;
      this.spinner.show();
      this.updateMYJSSICDDAssociation();
      return;
      // this.getContracts();
    }
    //  }
    this.spinner.show();
    this.successMsg = null;
    this.ErrorMessage = null;
    this.dataService.userDisplayInfo.UniversalEmail = this.UniversalEmail;
    this.accountSvc.updateUniversalLogin(this.dataService.userDisplayInfo.UniversalEmail, this.dataService.userDisplayInfo.LID)
      // .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.spinner.hide();
          console.log(data);

          this.dataService.userDisplayInfo.bearerToken = data.bearerToken;
          this.dataService.userDisplayInfo.id = data.id;
          this.showSuccessConfirmation = false;
          this.showFailConfirmation = false;
          this.successMsg = 'Please click Finish to continue with New MYJSSI. ';
          //  this.addContract = new AddContract();
          // this.spinner.show();
          // this.getContracts();
          this.step = 3;


        },
        err => {
          this.spinner.hide();
          console.log('addcontract', err);
          this.passwordConfirm = true;
        }

      );

  }
  onFinishClicked(): any {
    console.log('Finish');
    this.closeModel.emit(null);
  }

  Continue() {
    this.getContracts();
  }
  getContracts() {
    this.step = 4;
    if (this.successMsg !== '') {
      this.showSuccessConfirmation = true;
      this.showFailConfirmation = false;
    } else {
      this.showSuccessConfirmation = false;
      this.showFailConfirmation = true;
    }
    this.spinner.show();
    this.contractService.getContractList()
      .takeWhile(() => this.alive)
      .subscribe(
        contracts => {
          this.spinner.hide();
          console.log('User contracts loaded initially');
        },
        err => {
          //  this.showErrorConfirmation(err);
          console.log('Encountering error while getContractList: ' + err._body);
        }
      );
  }
  getchgPwdlink() {
    this.accountSvc.getUniversalVerificatonCode(this.UniversalEmail, this.dataService.userDisplayInfo.LID,
     this.dataService.userDisplayInfo.id)
    .takeWhile(() => this.alive)
     .subscribe(
       data => {

         console.log('after get token', data);
         this.chgpasswordURL = data;
         console.log(' this.chgpasswordURL ', this.chgpasswordURL );
         window.open( this.chgpasswordURL);

       },
       err => {

         console.log('after gettoken err', err);
       }
     );

  }
  wait2sec() {
   // alert('wait');
   return new Promise(function(resolve, reject) {
     setTimeout(function() {
       resolve();
     }, 2000);
   });
 }


  updateMYJSSICDDAssociation() {
    this.successMsg = null;
    this.ErrorMessage = null;
    this.dataService.userDisplayInfo.UniversalEmail = this.UniversalEmail;
    console.log('this.dataService.userDisplayInfo.UniversalEmail', this.dataService.userDisplayInfo.UniversalEmail);
    this.accountSvc.updateMYJSSICDDAssociation(this.dataService.userDisplayInfo.UniversalEmail, this.Password,
      this.dataService.userDisplayInfo.id, this.dataService.userDisplayInfo.LID)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.spinner.hide();
          console.log('after email update', data);
          console.log('this.dataService.userDisplayInfo.bearerToken', this.dataService.userDisplayInfo.bearerToken);
          this.dataService.userDisplayInfo.bearerToken = data.loginResult.bearerToken;
          this.dataService.userDisplayInfo.id = data.loginResult.id;
          console.log('this.dataService.userDisplayInfo.bearerToken after', this.dataService.userDisplayInfo.bearerToken);
          this.showSuccessConfirmation = false;
          this.showFailConfirmation = false;
          this.successMsg = 'Please click Finish to continue with New MYJSSI. ';
          //  this.addContract = new AddContract();
          // this.spinner.show();
          //   this.getContracts();

          this.step = 3;


        },
        err => {
          this.spinner.hide();
          console.log('addcontract', err);
          this.passwordConfirm=true;
        }

      );


  }
  demoClick() {
   // alert('democlick');
    this.showSuccessConfirmation = true;
    this.step = 4;
  }
  clearData() {
    // this.addContract = new AddContract();
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
    this.ErrorMessage = null;
  }

  ngOnDestroy() {
    this.alive = false;
  }
  changeSubStep() {
    this.onChangeSubStep.emit(this.subStep);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/account/login/universallogin/universallogin.component.ts